import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/**
 * @internal
 */

/**
 * @internal
 */

export default class ExportRegistry {
  constructor() {
    _defineProperty(this, "moduleExports", new Map());
    _defineProperty(this, "onLoads", new Map());
    _defineProperty(this, "chunks", new Map());
    _defineProperty(this, "chunkModules", new Map());
    _defineProperty(this, "_revisions", null);
    _defineProperty(this, "_webpack_runtimes", {
      // @ts-ignore
      core: window.testing ? null : __webpack_require__
    });
  }
  add(namespace, id, object) {
    this.moduleExports.set(namespace, this.moduleExports.get(namespace) || new Map());
    this.moduleExports.get(namespace)?.set(id, object);
    this.onLoads.get(namespace)?.get(id)?.forEach(handler => handler(object));
  }
  onLoad(namespace, id, handler) {
    if (this.moduleExports.has(namespace) && this.moduleExports.get(namespace)?.has(id)) {
      handler(this.moduleExports.get(namespace)?.get(id));
    } else {
      this.onLoads.set(namespace, this.onLoads.get(namespace) || new Map());
      this.onLoads.get(namespace)?.set(id, this.onLoads.get(namespace)?.get(id) || []);
      this.onLoads.get(namespace)?.get(id)?.push(handler);
    }
  }
  get(namespace, id) {
    const module = this.moduleExports.get(namespace)?.get(id);
    const extensionEnabled = namespace in flarum.extensions || namespace === 'core';
    const error = `No module found for ${namespace}:${id}`;

    // @ts-ignore
    if (!module && extensionEnabled && flarum.debug) {
      throw new Error(error);
    } else if (!module && extensionEnabled) {
      console.warn(error);
    }
    return module;
  }
  checkModule(namespace, id) {
    const exists = this.moduleExports.has(namespace) && this.moduleExports.get(namespace)?.has(id) || false;
    return exists ? this.get(namespace, id) : false;
  }
  addChunkModule(chunkId, moduleId, namespace, urlPath) {
    if (!this.chunks.has(chunkId.toString())) {
      this.chunks.set(chunkId.toString(), {
        namespace,
        urlPath,
        modules: [urlPath]
      });
    } else {
      this.chunks.get(chunkId.toString())?.modules?.push(urlPath);
    }
    this.chunkModules.set(`${namespace}:${urlPath}`, {
      chunkId: chunkId.toString(),
      moduleId: moduleId.toString()
    });
  }
  getChunk(chunkId) {
    const chunk = this.chunks.get(chunkId.toString()) ?? null;
    if (!chunk) {
      console.warn(`[Export Registry] No chunk by the ID ${chunkId} found.`);
      return null;
    }
    return chunk;
  }
  async loadChunk(original, url, done, key, chunkId) {
    // @ts-ignore
    app.alerts.showLoading();
    return await original(this.chunkUrl(chunkId) || url, function () {
      // @ts-ignore
      app.alerts.clearLoading();
      return done(...arguments);
    }, key, chunkId);
  }
  chunkUrl(chunkId) {
    const chunk = this.getChunk(chunkId.toString());
    if (!chunk) return null;
    this._revisions ??= JSON.parse(document.getElementById('flarum-rev-manifest')?.textContent ?? '{}');

    // @ts-ignore cannot import the app object here, so we use the global one.
    const path = `${app.forum.attribute('jsChunksBaseUrl')}/${chunk.namespace}/${chunk.urlPath}.js`;

    // The paths in the revision are stored as (relative path from the assets path) + the path.
    // @ts-ignore
    const assetsPath = app.forum.attribute('assetsBaseUrl');
    const key = path.replace(assetsPath, '').replace(/^\//, '');
    const revision = this._revisions[key];
    return revision ? `${path}?v=${revision}` : path;
  }
  async asyncModuleImport(path) {
    const [namespace, id] = this.namespaceAndIdFromPath(path);
    const module = this.chunkModules.get(`${namespace}:${id}`);
    if (!module) {
      throw new Error(`No chunk found for module ${namespace}:${id}`);
    }

    // @ts-ignore
    const wr = this._webpack_runtimes[namespace] ?? __webpack_require__;
    return await wr.e(module.chunkId).then(wr.bind(wr, module.moduleId)).then(() => {
      const m = this.get(namespace, id);
      m.default ??= m;
      return m;
    });
  }
  clear() {
    this.moduleExports.clear();
    this.onLoads.clear();
    this.chunks.clear();
    this.chunkModules.clear();
  }
  namespaceAndIdFromPath(path) {
    // Either we get a path like `flarum/forum/components/LogInModal` or `ext:flarum/tags/forum/components/TagPage`.
    const matches = /^(?:ext:([^\/]+)\/(?:flarum-(?:ext-)?)?([^\/]+)|(flarum))(?:\/(.+))?$/.exec(path);
    const id = matches[4];
    let namespace;
    if (matches[1]) {
      namespace = `${matches[1]}-${matches[2]}`;
    } else {
      namespace = 'core';
    }
    return [namespace, id];
  }
}